export default __webpack_public_path__ + "static/media/paid_assess.42b5a5aa.svg";